export default __webpack_public_path__ + "static/media/template_4.b70881b7.png";